<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 17:37:33
-->

<template>
  <div class="pie">
    <!-- <div class="tab">
      <div :class="['tab-item', { active: type == 1 }]" @click="typeChange(1)">月</div>
      <div :class="['tab-item', { active: type == 2 }]" @click="typeChange(2)">季</div>
      <div :class="['tab-item', { active: type == 3 }]" @click="typeChange(3)">年</div>
    </div> -->
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>产品类型销售量统计(吨)</span>
    </div>
    <div id="SaleTypeChart" style="width:630px;height:380px"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { productSale } from '@/api/dashboard'
import to from 'await-to'
let myChart
let timer
export default {
  data() {
    return {
      colorMap: [
        ['#12FEE0', '#026DB2'],
        ['#6DD400', '#44D7B6'],
        ['#5C64FF', '#6988F8'],
        ['#0E5FFF', '#2DE1FD'],
        ['#FFA600', '#FEDB65'],
        ['#FF9C92', '#FA2C19'],
        ['#C4A9E7', '#9270CA'],
        ['#FFD8B8', '#FF9D4D'],
      ],
      data: [],
      option: {},
      type: 3,
      currentIndex: 0,
    }
  },
  async mounted() {
    myChart = echarts.init(document.getElementById('SaleTypeChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    clearInterval(timer)
  },
  methods: {
    async initData() {
      const [res, err] = await to(productSale({ type: this.type }))
      if (err) return
      this.data = res.data.map((item, index) => {
        if (index < this.colorMap.length) {
          return {
            value: item.quantity,
            name: item.typeName,
            itemStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  // !! 在此添加渐变过程色 !!
                  { offset: 0, color: this.colorMap[index][0] },
                  { offset: 1, color: this.colorMap[index][1] },
                ],
              },
            },
          }
        } else {
          return {
            value: item.quantity,
            name: item.typeName,
          }
        }
      })
      this.initChart()
    },
    initChart() {
      this.option = {
        // 提示框特效
        tooltip: {
          trigger: 'item',
          show: true,
          enterable: true,
          confine: true,
          backgroundColor: 'rgba(4, 29, 46, 0.95)',
          borderColor: '#50E0FF',
          borderWidth: 2,
          padding: [15, 20],
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
          extraCssText: `
            box-shadow: 0 0 20px rgba(80, 224, 255, 0.6), 
                        inset 0 0 15px rgba(80, 224, 255, 0.1);
            border-radius: 8px;
            backdrop-filter: blur(10px);
            z-index: 9999;
            animation: tooltipFadeIn 0.3s ease-out;
          `,
          formatter: params => {
            const startColor = this.colorMap[params.dataIndex % this.colorMap.length][0]
            return `
              <div style="position: relative; padding: 5px;">
                <div style="
                  position: absolute;
                  left: -10px;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 40px;
                  background: linear-gradient(to bottom, ${startColor}, ${
              this.colorMap[params.dataIndex % this.colorMap.length][1]
            });
                  border-radius: 2px;
                  box-shadow: 0 0 10px ${startColor};
                "></div>
                <div style="padding-left: 10px;">
                  <div style="
                    font-size: 18px; 
                    font-weight: bold; 
                    color: ${startColor};
                    text-shadow: 0 0 10px ${startColor}80;
                    margin-bottom: 8px;
                  ">${params.name}</div>
                  <div style="
                    color: #fff; 
                    font-size: 24px; 
                    font-weight: bold;
                    margin-bottom: 6px;
                  ">${params.value.toLocaleString()} <span style="font-size: 16px; color: #899DBF;">吨</span></div>
                  <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 6px;
                    border-top: 1px dashed rgba(80, 224, 255, 0.3);
                  ">
                    <span style="color: #899DBF; font-size: 14px;">占比</span>
                    <span style="
                      color: ${startColor}; 
                      font-size: 20px; 
                      font-weight: bold;
                      text-shadow: 0 0 10px ${startColor}80;
                    ">${params.percent}%</span>
                  </div>
                </div>
              </div>
            `
          },
        },
        // 环形中心文字
        graphic: [
          {
            type: 'text',
            left: '15%',
            top: '47%',
            style: {
              text: this.data[this.currentIndex].name,
              fill: '#fff',
              width: 120,
              height: 48,
              fontSize: 23,
              textAlign: 'center',
              fontFamily: 'Source Han Sans CN',
            },
          },
          {
            type: 'text',
            left: '15%',
            top: '55.2%',
            style: {
              text: this.data[this.currentIndex].value,
              fill: '#50E0FF',
              width: 120,
              height: 48,
              fontSize: 23,
              fontWeight: 500,
              textAlign: 'center',
              fontFamily: 'Source Han Sans CN',
            },
          },
        ],
        //线条相关
        series: [
          // 外圈发光装饰
          {
            name: '发光圈',
            type: 'pie',
            radius: ['82%', '84%'],
            center: ['26%', '55%'],
            silent: true,
            itemStyle: {
              color: 'rgba(80, 224, 255, 0.1)',
            },
            label: { show: false },
            data: [{ value: 1 }],
            animation: false,
          },
          // 主环形图
          {
            name: '总计',
            type: 'pie',
            radius: ['50%', '80%'], //【粗细，大小】
            center: ['26%', '55%'], //【左右，上下】
            data: this.data,
            hoverAnimation: true,
            hoverOffset: 10,
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: 'transparent',
              borderWidth: 0,
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.3)',
            },
            label: {
              normal: {
                show: false,
              },
            },
            emphasis: {
              scale: true,
              scaleSize: 30,
              itemStyle: {
                shadowBlur: 25,
                shadowOffsetX: 0,
                shadowColor: 'rgba(80, 224, 255, 0.6)',
                borderColor: '#50E0FF',
                borderWidth: 3,
              },
            },
            labelLine: {
              normal: {
                show: false,
                length: 17,
                length2: 39,
                lineStyle: {
                  color: '#899DBF',
                },
              },
              emphasis: {
                show: true,
                type: 'cross',
                length: 17,
                length2: 39,
                lineStyle: {
                  color: '#899DBF',
                },
              },
            },
          },
          // 内圈装饰
          {
            name: '内圈',
            type: 'pie',
            radius: ['45%', '46%'],
            center: ['26%', '55%'],
            silent: true,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(80, 224, 255, 0.3)' },
                  { offset: 0.5, color: 'rgba(80, 224, 255, 0.1)' },
                  { offset: 1, color: 'rgba(80, 224, 255, 0.3)' },
                ],
              },
            },
            label: { show: false },
            data: [{ value: 1 }],
            animation: false,
          },
        ],
        /* 设置图例样式 */
        legend: {
          // orient: 'vertical',
          top: 30,
          right: 30,
          itemHeight: 17, // 图例icon高度
          itemWidth: 17, // 图例icon宽度
          icon: 'circle',
          width: 240,
          height: 70,
          itemGap: 26, //图例间距
          textStyle: {
            fontSize: 21,
            color: '#899DBF',
            fontFamily: 'Source Han Sans CN',
          },
          data: this.legendData,
        },
      }
      myChart.setOption(this.option)
      this.timeSetIntervalFun()
    },
    timeSetIntervalFun() {
      if (timer) clearInterval(timer)
      // 初始化第一个选中
      this.highlightCurrent()
      timer = setInterval(() => {
        const prevIndex = this.currentIndex
        var dataLen = this.data.length
        this.currentIndex = (this.currentIndex + 1) % dataLen
        // 取消之前扇区的高亮
        myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 1,
          dataIndex: prevIndex,
        })
        // 高亮当前图形
        this.highlightCurrent()
      }, 3000)
    },
    highlightCurrent() {
      const currentData = this.data[this.currentIndex]
      const currentColor = this.colorMap[this.currentIndex % this.colorMap.length]
      // 更新数据，给当前选中的扇区添加放大和发光效果
      const newData = this.data.map((item, index) => {
        const isSelected = index === this.currentIndex
        return {
          ...item,
          itemStyle: {
            ...item.itemStyle,
            shadowBlur: isSelected ? 30 : 10,
            shadowColor: isSelected ? 'rgba(80, 224, 255, 0.8)' : 'rgba(0, 0, 0, 0.3)',
            borderColor: isSelected ? '#50E0FF' : 'transparent',
            borderWidth: isSelected ? 3 : 0,
          },
          // 使用 emphasis 配置来实现放大效果
          emphasis: {
            scale: isSelected,
            scaleSize: isSelected ? 12 : 10,
            itemStyle: {
              shadowBlur: isSelected ? 20 : 10,
              shadowColor: isSelected ? 'rgba(80, 224, 255, 0.5)' : 'rgba(0, 0, 0, 0.3)',
              borderColor: '#50E0FF',
              borderWidth: 3,
            },
          },
        }
      })
      // 更新图表数据
      myChart.setOption({
        series: [
          {},
          {
            data: newData,
          },
        ],
        graphic: [
          {
            type: 'text',
            left: '21%',
            top: '45%',
            style: {
              text: currentData.name,
              fill: currentColor[0],
              width: 120,
              height: 48,
              fontSize: 20,
              textAlign: 'center',
              fontFamily: 'Source Han Sans CN',
              fontWeight: 'bold',
            },
          },
          {
            type: 'text',
            left: '21%',
            top: '53%',
            style: {
              text: currentData.value.toLocaleString(),
              fill: '#fff',
              width: 120,
              height: 48,
              fontSize: 32,
              fontWeight: 'bold',
              textAlign: 'center',
              fontFamily: 'DIN Alternate',
              textShadow: `0 0 20px ${currentColor[0]}80`,
            },
          },
          {
            type: 'text',
            left: '21%',
            top: '63%',
            style: {
              text: '吨',
              fill: '#899DBF',
              width: 120,
              height: 48,
              fontSize: 14,
              textAlign: 'center',
              fontFamily: 'Source Han Sans CN',
            },
          },
        ],
      })
      // 触发高亮动作来实现放大效果
      myChart.dispatchAction({
        type: 'highlight',
        seriesIndex: 1,
        dataIndex: this.currentIndex,
      })
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
  },
}
</script>
<style lang="scss" scoped>
.pie {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 30px;
  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    img {
      margin-right: 3px;
    }
  }
  .tab {
    z-index: 99;
    position: absolute;
    right: 26px;
    top: 36px;
    display: flex;
    .tab-item {
      width: 64px;
      height: 31px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #15535e;
      text-align: center;
      line-height: 29px;
      color: rgba(255, 255, 255, 0.8);
      &.active {
        color: #66ffff;
      }
    }
  }
}
</style>
